import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { PreferencesContext } from 'context/PreferencesProvider';
import useAPI from './useAPI';
import useGetUser from './useGetUser';
import { useAGLOCampaign } from './useAGLOCampaign';

// Both Dashboard and Deposit consume this endpoint with the same active scope.
const useDepositStats = (useSelectedCampaign = false) => {
  const { api } = useAPI();
  const { user, activeOrganizationId, activeRole, isConnected, isAGLO, isSuperAdmin, isAgency } = useGetUser();
  const { campaignYear } = useContext(PreferencesContext);
  const campaign = useAGLOCampaign();
  const selectedYear = useSelectedCampaign && isAGLO ? campaign.selectedCampaignYear : campaignYear;
  const params = useSelectedCampaign && isAGLO ? campaign.params : { year: campaignYear };

  return useQuery({
    queryKey:
      useSelectedCampaign && isAGLO
        ? ['deposit/stats/default/', selectedYear, user?.id, activeOrganizationId, activeRole, params]
        : ['deposit/stats/default/', selectedYear, user?.id, activeOrganizationId, activeRole],
    queryFn: api.list('deposit/stats/default/', params),
    enabled: !!(
      isConnected &&
      user?.id &&
      activeOrganizationId &&
      activeRole &&
      selectedYear &&
      (isAGLO || isSuperAdmin || isAgency)
    ),
    keepPreviousData: false,
    refetchOnMount: true,
    staleTime: 0,
  });
};

export default useDepositStats;
